import { useState, useEffect, useCallback } from 'react';
import { isAuthenticated, getToken, clearSession } from '@/lib/session';
import { apiFetch } from '@/lib/api';

export function useAuth() {
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const check = useCallback(async () => {
    if (!getToken()) {
      setIsAuth(false);
      setIsLoading(false);
      return;
    }
    if (!isAuthenticated()) {
      setIsAuth(false);
      setIsLoading(false);
      return;
    }
    try {
      const res = await apiFetch('/users/profile', 'GET');
      if (res.ok) {
        setIsAuth(true);
      } else {
        clearSession();
        setIsAuth(false);
      }
    } catch {
      clearSession();
      setIsAuth(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  return { isAuth, isLoading, refetch: check };
}
